<template>
    <BaseMapShell v-model:panelOpen="panelOpen" v-model:rightPanelOpen="rightPanelOpen" :center="center" :zoom="zoom"
        :bounds="bounds" :max-bounds="maxBounds" :maxZoom="19" :minZoom="3">
        <!-- Slot panel-sections : options spécifiques corridoring -->
        <template #panel-sections>
            <PanelCorridoringRadiusSection v-model="showCircles" id="toggle-circles-corridoring" />
        </template>

        <!-- Contenu spécifique corridoring -->
        <CorridoringLayer :positions="positions" :geofencings="geofencings" :show-radius="showCircles"
            :selected-position-id="selectedPos?.id" @select-position="selectPosition" />

        <CorridoringDisplay :corridoringId="$route.params.corridoringId" />

        <!-- Right panel dédié aux points de corridoring -->
        <template #right-panel>
            <RightCorridoringPointPanel v-if="selectedPos" :position="selectedPos" :saving="savingRadius"
                @update-radius="handleUpdateRadius" />
        </template>
    </BaseMapShell>
</template>

<script>
import CorridoringLayer from "../Components/layers/CorridoringLayer.vue";
import BaseMapShell from "../BaseMapShell.vue";
import PanelCorridoringRadiusSection from '../Components/sidePanel/PanelCorridoringRadiusSection.vue';
import RightCorridoringPointPanel from "../Components/rightPanel/RightCorridoringPointPanel.vue";
import CorridoringDisplay from "../Components/CorridoringDisplay.vue";
import CorridoringService from "@/services/corridoring.service.js";
import { computePaddedBounds } from "../composables/useBounds";
import { normalizePositions } from "../composables/usePositions";

export default {
    name: "CorridoringMap",
    components: {
        BaseMapShell,
        PanelCorridoringRadiusSection,
        CorridoringLayer,
        CorridoringDisplay,
        RightCorridoringPointPanel
    },
    data() {
        return {
            panelOpen: false,
            rightPanelOpen: false,
            zoom: 13,
            center: [48.9571487, 2.1941876],
            bounds: [],
            maxBounds: [],
            positions: [],
            geofencings: [],
            showCircles: false,
            selectedPos: null,
            savingRadius: false,
        };
    },
    watch: {
        $route() {
            this.getPositions();
        },
    },
    mounted() {
        this.getPositions();
    },
    methods: {
        async getPositions() {
            this.selectedPos = null;
            this.rightPanelOpen = false;

            try {
                const response = await CorridoringService.getCorridoringFullData(this.$route.params.corridoringId);
                const data = response?.data || {};

                this.positions = normalizePositions(data.corridoringPositions || []);
                this.geofencings = Array.isArray(data.geofencings) ? data.geofencings : [];

                const geofencingPositions = this.geofencings.flatMap((geofencing) => {
                    const points = Array.isArray(geofencing.geofencingPoints)
                        ? geofencing.geofencingPoints
                        : [];

                    return points.map((point) => ({
                        latitude: Number(point.latitude),
                        longitude: Number(point.longitude),
                    }));
                });

                this.bounds = computePaddedBounds([
                    ...this.positions,
                    ...geofencingPositions,
                ]);
            } catch (e) {
                console.error("Erreur lors du chargement du corridoring complet", e);
                this.selectedPos = null;
                this.rightPanelOpen = false;
                this.positions = [];
                this.geofencings = [];
                this.bounds = [];
            }
        },
        selectPosition(position) {
            this.selectedPos = position || null;

            this.rightPanelOpen = !!this.selectedPos;
        },
        async handleUpdateRadius(newRadius) {
            if (!this.selectedPos) return;

            try {
                this.savingRadius = true;

                const positionId = this.selectedPos.id;

                await CorridoringService.updatePositionRadius(positionId, newRadius);

                this.positions = this.positions.map((position) => {
                    if (String(position.id) !== String(positionId)) {
                        return position;
                    }

                    return {
                        ...position,
                        radius: newRadius,
                    };
                });

                this.selectedPos = {
                    ...this.selectedPos,
                    radius: newRadius,
                };

            } catch (e) {
                console.error("Erreur lors de la mise à jour du radius", e);
            } finally {
                this.savingRadius = false;
            }
        },
    },
};
</script>
